import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useContext} from "react";

import AuthContext from "context/AuthContext";
import ModalQueuePayload from "./ModalQueuePayload";
import {useState} from "react";
import ConditionalRender from "../ConditionalRender";

const Queue = ({item}) => {
    const {user} = useContext(AuthContext);
    const [show, setShow] = useState(false);

    const handleShow = () => setShow(true);
    const getStyle = () => {
        return {
            color: item.status ? "#ff9090" : "#95ca6d",
            cursor: "pointer",
        };
    };
    const getIcon = () => {
        if (user.is_admin && item.status) {
            return (
                <>
                    <FontAwesomeIcon
                        icon="circle"
                        className="ms-2"
                        style={getStyle()}
                        onClick={handleShow}
                    />
                    <ConditionalRender condition={show}>
                        <ModalQueuePayload show={show} setShow={setShow} item={item} />
                    </ConditionalRender>
                </>
            );
        } else {
            return (
                <FontAwesomeIcon
                    icon="circle"
                    className="ms-2"
                    style={{color: item.status ? "#ff9090" : "#95ca6d"}}
                />
            );
        }
    };

    return getIcon();
};

export default Queue;
